/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reward shown for immediate participation
 * @export
 * @interface UpdateCompetitionBodyOnboardingSectionInstantReward
 */
export interface UpdateCompetitionBodyOnboardingSectionInstantReward {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSectionInstantReward
     */
    header?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSectionInstantReward
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSectionInstantReward
     */
    icon?: string;
}

/**
 * Check if a given object implements the UpdateCompetitionBodyOnboardingSectionInstantReward interface.
 */
export function instanceOfUpdateCompetitionBodyOnboardingSectionInstantReward(value: object): value is UpdateCompetitionBodyOnboardingSectionInstantReward {
    return true;
}

export function UpdateCompetitionBodyOnboardingSectionInstantRewardFromJSON(json: any): UpdateCompetitionBodyOnboardingSectionInstantReward {
    return UpdateCompetitionBodyOnboardingSectionInstantRewardFromJSONTyped(json, false);
}

export function UpdateCompetitionBodyOnboardingSectionInstantRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompetitionBodyOnboardingSectionInstantReward {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'] == null ? undefined : json['header'],
        'description': json['description'] == null ? undefined : json['description'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function UpdateCompetitionBodyOnboardingSectionInstantRewardToJSON(json: any): UpdateCompetitionBodyOnboardingSectionInstantReward {
    return UpdateCompetitionBodyOnboardingSectionInstantRewardToJSONTyped(json, false);
}

export function UpdateCompetitionBodyOnboardingSectionInstantRewardToJSONTyped(value?: UpdateCompetitionBodyOnboardingSectionInstantReward | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

